import { schema } from "normalizr";
import { EmployeeSchema } from "./index";
import { EmployeePayrollIncentiveArraySchema } from "./employee-payroll-incentive";

const EmployeePayrollSchema = new schema.Entity("employeePayrolls", {
  employee: EmployeeSchema,
  employeePayrollIncentives: EmployeePayrollIncentiveArraySchema
});

export { EmployeePayrollSchema };